import { render, staticRenderFns } from "./what-happened-to-instagram-igtv.vue?vue&type=template&id=f03f7eb6"
import script from "./what-happened-to-instagram-igtv.vue?vue&type=script&lang=js"
export * from "./what-happened-to-instagram-igtv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports